document.addEventListener("DOMContentLoaded", function () {
  var countdownContainer = document.querySelector(".countdown-container");

  // Check if the countdownContainer element exists
  if (countdownContainer) {
    var countdownDays = countdownContainer.querySelector(
      ".countdown-days span"
    );
    var countdownHours = countdownContainer.querySelector(
      ".countdown-hours span"
    );
    var countdownMinutes = countdownContainer.querySelector(
      ".countdown-minutes span"
    );
    var countdownSeconds = countdownContainer.querySelector(
      ".countdown-seconds span"
    );

    var days = parseInt(countdownDays.textContent);
    var hours = parseInt(countdownHours.textContent);
    var minutes = parseInt(countdownMinutes.textContent);
    var seconds = parseInt(countdownSeconds.textContent);

    function updateCountdown() {
      if (seconds > 0) {
        seconds--;
      } else {
        seconds = 59;
        if (minutes > 0) {
          minutes--;
        } else {
          minutes = 59;
          if (hours > 0) {
            hours--;
          } else {
            hours = 23;
            if (days > 0) {
              days--;
            }
          }
        }
      }

      countdownDays.textContent = days;
      countdownHours.textContent = hours;
      countdownMinutes.textContent = minutes;
      countdownSeconds.textContent = seconds;
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }
});
